import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-aus-verterinary-inspection-form-info',
  templateUrl: './aus_veterinary_inspection_form.component.html',
  styleUrls: []
})
export class AusVerterinaryInspectionFormComponent {
  @Input() noteFields: any[];
  @Input() newNote: any;
  @Input() noteForm: any;
  @Input() yesLabel: string = 'Yes';
  @Input() noLabel: string = 'No';

  public ratings = ["0", "1", "2", "3", "4", "5"];


  public optionalFields = ['report_by_veterinarian']
  public reviewMenus = [
    {
      type: 'LF',

      field: {
        id: 'LF_Lameness_Grade_select'
      },
      label: "LF Lameness Grade"
    },
    {
      type: 'RF',
      field: {
        id: 'RF_Lameness_Grade_select'
      },
      label: "RF Lameness Grade"
    },
    {
      type: 'LH',
      field: {
        id: 'LH_Lameness_Grade_select'
      },
      label: "LH Lameness Grade"
    },
    {
      type: 'RH',
      field: {
        id: 'RH_Lameness_Grade_select'
      },
      label: "RH Lameness Grade"
    }
  ]
  getToggleInputName(field: any): string {
    var name = `comments[${field.id}_text]`;
    return name;
  }

  getSelectInputName(field: any): string {
    var name = `comments[${field.id}]`;
    return name;
  }

  getSelectedInputValue(field: any): string {
    var name = `comments[${field.id}]`;
    return this.newNote[name];
  }

  updateTextFieldValue(_newNote: any, field: any) {
    this.newNote[field.name] = !this.newNote[field.name];
    if (!this.newNote[field.name]) {
      this.newNote[field.name] = ''
      this.newNote[`comments[${field.id}_text]`] = ""
    }
  }

  setRatingValue(e, item) {
    var fieldName = this.getSelectInputName(item.field)
    this.newNote[fieldName] = +e.id;
    if (this.newNote[fieldName] < 2) {
      this.newNote[this.getToggleInputName(item.field)] = ""
    }
  }

  getActiveRating(item: any) {
    var fieldName = this.getSelectInputName(item.field);
    if (this.newNote[fieldName] != undefined || this.newNote[fieldName] != null) {
      var selectedItem = [{
        id: `${this.newNote[fieldName]}`,
        text: `${this.newNote[fieldName]}`
      }]
      return selectedItem;
    }

    return []
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/common/aus-notes/aus_veterinary_inspection_form.component.ts